import { create } from 'zustand';
import { setWorkspaceCookies } from '../cookies/workspace.cookies';
import { IWorkspace, IWorkspaceStore } from '../interfaces/workspace.interface';
import { getWorkspaces, createWorkspace } from '../api/workspace';
import { connectSocket } from '../sockets/socket.config';
import { requestersSocket } from '../sockets/modules/requests-socket.module';

export const useWorkspaceStore = create<IWorkspaceStore>((set) => ({
    data: null,
    loading: false,
    error: null,
    setLoading: (loading: boolean) => set({ loading }),
    setError: (error: string | null) => set({ error }),
    setData: (data: IWorkspace | null) => set({ data }),
}));

export const startLoadWorkspace = async () => {
    try {
        useWorkspaceStore.setState(() => ({ loading: true }));
        const { body }: any = await getWorkspaces();
        if (body.length > 0) {
            const workspaceID = body[0]._id;
            setWorkspaceCookies({ workspaceID });
            connectSocket();
            useWorkspaceStore.setState(() => ({ data: body[0], loading: false }));
        } else {
            useWorkspaceStore.setState(() => ({ loading: false }));
        }
    } catch (error: any) {
        console.error('[startLoadWorkspace] Error', error);
        useWorkspaceStore.setState(() => ({ loading: false, error: error.message }));
    }
};

export const startCreateWorkspace = async (values: any) => {
    try {
        useWorkspaceStore.setState(() => ({ loading: true }));
        const { body }: any = await createWorkspace(values);
        useWorkspaceStore.setState(() => ({ data: body, loading: false }));
        setWorkspaceCookies({
            workspaceID: body._id,
        });
    } catch (error: any) {
        console.error('[startCreateWorkspace] Error', error);
        useWorkspaceStore.setState(() => ({ loading: false, error: error.message }));
    }
};
